import { AlertTitle, IconButton, Alert as MuiAlert, Stack, Typography } from '@mui/material';
import { colors, CrossSmallIcon, palette } from '@silbo/ui';
import React, { ReactNode } from 'react';
import { toast as sonnerToast } from 'sonner';

export type Severity = 'success' | 'info' | 'warning' | 'error';

type AlertProps = {
  id: string | number;
  content: ReactNode;
  severity?: Severity;
  icon?: ReactNode;
  title?: ReactNode;
  action?: ReactNode;
  dismissible?: boolean;
};

const Alert: React.FC<AlertProps> = ({
  id,
  content,
  severity = 'success',
  icon,
  title,
  action,
  dismissible = true,
}) => {
  return (
    <div style={{ position: 'relative' }}>
      <MuiAlert
        severity={severity}
        icon={icon ? icon : undefined}
        action={
          action && (
            <Stack direction="row" spacing={2} height="100%">
              {action}
            </Stack>
          )
        }
        sx={{ border: `1px solid ${borderColor[severity]}`, '.MuiAlert-action': { p: 0, marginLeft: 2 } }}
      >
        {title && (
          <AlertTitle>
            <Typography variant="h4">{title}</Typography>
          </AlertTitle>
        )}
        {typeof content === 'string' ? <Typography>{content}</Typography> : <div>{content}</div>}
      </MuiAlert>
      {dismissible && (
        <IconButton
          size="medium"
          variant="outlined"
          disableRipple
          sx={{
            position: 'absolute',
            top: -8,
            right: -8,
            zIndex: 10,
            backgroundColor: palette[severity].light,
            borderColor: borderColor[severity],
            color: palette[severity].main,
            '&:hover': {
              backgroundColor: palette[severity].light,
            },
          }}
          onClick={() => sonnerToast.dismiss(id)}
        >
          <CrossSmallIcon />
        </IconButton>
      )}
    </div>
  );
};

const borderColor: Record<Severity, string> = {
  error: colors.red[20],
  warning: colors.yellow[20],
  info: colors.blue[20],
  success: colors.green[20],
};

export default Alert;
